var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"iframeEl",staticClass:"iframe--document-embed",attrs:{"height":_vm.height,"width":_vm.width,"frameborder":"0","title":_vm.title},on:{"load":_vm.loadIframe,"error":_vm.reloadIframe}})])}
var staticRenderFns = []

export { render, staticRenderFns }